import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { createUser } from '../services/usersService';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../../components/Dialog';
import UserForm from './UserForm';
import { useAuth } from '../../../contexts/authContext';

// ----------------------------------------------------------------------

export default function NewUserDialog({ onClose, ...dialogProps }) {
  const { enqueueSnackbar } = useSnackbar();
  const auth = useAuth();


  const handleUserCreate = async (values, actions) => {
    try {
      values.moderatorId = auth.user.id;
      await createUser(values);
      enqueueSnackbar(<FormattedMessage id='newUser.create.msg.success' defaultMessage='User successfully created' />, {
        variant: 'success',
      });
      onClose(true);
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id='newUser.create.msg.error' defaultMessage='Create user failed' />, {
        variant: 'error',
      });
      actions.setSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      {...dialogProps}
      onClose={handleClose}
      title={<FormattedMessage id='newUser.title' defaultMessage='Create User' />}
    >
      <UserForm
        onSubmit={handleUserCreate}
        changableLocations={true}
      />
    </Dialog>
  );
}

NewUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
